import { resolvedVisualVersion } from './landingPageVisualVersion';

export const landingPagePreviewUrl = (
  customURL: string,
  theme?: string,
): string => {
  const params = new URLSearchParams({ creator: customURL });
  if (theme) params.set('theme', theme);
  return `${import.meta.env.VITE_LANDING_PAGE_URL}/lp-preview?${params}`;
};

export const isLandingPagePreviewOffered = (
  customURL: string | null | undefined,
  visualVersion: number | null | undefined,
): boolean => !!customURL && resolvedVisualVersion(visualVersion) === 1;
